import { useState, useRef } from 'react';
import classnames from 'classnames/bind';
import { useInterval } from '@fuxi/eevee-hooks';
import { TitleText } from '@portalCommon/recommend';
import { LazyVideo } from '@commonPackage/components';
import { RECOMMEND_BANNER_LIST } from '../../../homeV3/help';
import styles from './index.module.less';

const cx = classnames.bind(styles);

type ListItem = {
  img: string;
  title?: string;
  video?: string;
};

interface AccordionProps {
  activeWidth?: number;
  imgHeight?: number;
  imgWidth?: number;
  list: ListItem[];
}

const Accordion = (props: AccordionProps) => {
  const { imgWidth = 200, imgHeight = 440, activeWidth = 600, list } = props;

  const [activeIndex, setActiveIndex] = useState(Math.floor(list.length / 2));

  const timer = useRef<number | undefined>(2500);
  const listVideRefs = useRef<(HTMLVideoElement | null)[]>([]);

  useInterval(() => {
    setActiveIndex(activeIndex + 1 >= list.length ? 0 : activeIndex + 1);
  }, timer.current);

  return (
    <div
      className={cx('accordion-wrapper')}
      onMouseEnter={() => {
        timer.current = undefined;
      }}
      onMouseLeave={() => {
        timer.current = 2500;
      }}>
      {list.map((item, index) => {
        return (
          <div
            key={`accordion-item-${index}`}
            onClick={() => {
              setActiveIndex(index);
            }}
            className={cx('accordion-item', { active: activeIndex === index })}
            style={{
              backgroundImage: `url('${item.img}')`,
              width: activeIndex === index ? activeWidth : imgWidth,
              height: imgHeight,
            }}>
            {item.video && (
              <LazyVideo
                wrapperStyle={{
                  width: '100%',
                  height: '100%',
                }}
                src={item.video}
                ref={el => (listVideRefs.current[index] = el)}
                preload="auto"
                loop
                muted
                autoPlay>
                <source src={item.video} />
              </LazyVideo>
            )}
            {/* 遮罩 */}
            <div className={cx('accordion-item-mask')}></div>
            <div className={cx('accordion-item-bottom')}>
              {item.title && <span className={cx('accordion-title')}>{item.title}</span>}
              <span className={cx('accordion-active-line')}></span>
            </div>
          </div>
        );
      })}
    </div>
  );
};
export function CaseScroll() {
  return (
    <div className={cx('case-scroll')}>
      <TitleText text="可推荐场景" style={{ marginBottom: 88 }} />
      <Accordion list={RECOMMEND_BANNER_LIST} />
      <div className={cx('case-round')}>......</div>
    </div>
  );
}
